import { Fragment } from 'react';
import Text from './TextFilter';
import Checkbox from './CheckboxFilter';
import Radio from './RadioFilter';
import Group from './GroupFilter';
import SingleSelectFilter from './SingleSelectFilter';
export var conditionalFilterType = {
    text: 'text',
    checkbox: 'checkbox',
    radio: 'radio',
    custom: 'custom',
    group: 'group',
    singleSelect: 'singleSelect',
};
export var typeMapper = {
    text: Text,
    checkbox: Checkbox,
    radio: Radio,
    custom: Fragment,
    group: Group,
    singleSelect: SingleSelectFilter,
};
export function identifyComponent(type, props) {
    return true;
}
//# sourceMappingURL=conditionalFilterConstants.js.map